import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Timeline } from "./Timeline";
import { Tone } from "../Tone";
/**
 * Represents a single value which is gettable and settable in a timed way
 */

export var TimelineValue = /*#__PURE__*/function (_Tone) {
  _inherits(TimelineValue, _Tone);

  var _super = _createSuper(TimelineValue);

  /**
   * @param initialValue The value to return if there is no scheduled values
   */
  function TimelineValue(initialValue) {
    var _this;

    _classCallCheck(this, TimelineValue);

    _this = _super.call(this);
    _this.name = "TimelineValue";
    /**
     * The timeline which stores the values
     */

    _this._timeline = new Timeline({
      memory: 10
    });
    _this._initialValue = initialValue;
    return _this;
  }
  /**
   * Set the value at the given time
   */


  _createClass(TimelineValue, [{
    key: "set",
    value: function set(value, time) {
      this._timeline.add({
        value: value,
        time: time
      });

      return this;
    }
    /**
     * Get the value at the given time
     */

  }, {
    key: "get",
    value: function get(time) {
      var event = this._timeline.get(time);

      if (event) {
        return event.value;
      } else {
        return this._initialValue;
      }
    }
  }]);

  return TimelineValue;
}(Tone);